import { call, put, takeLatest } from 'redux-saga/effects';
import { getCloudProviders } from './data';
import { errorReceiveCloudProviders, failedReceiveCloudProviders, receiveCloudProviders } from './slice';
export function* requestCloudProviders() {
    try {
        const cloudProviders = yield call(getCloudProviders);
        if (!cloudProviders || Object.keys(cloudProviders).length < 1) {
            yield put(errorReceiveCloudProviders());
        }
        else {
            yield put(receiveCloudProviders(cloudProviders));
        }
    }
    catch (e) {
        yield put(failedReceiveCloudProviders());
    }
}
export function* watchRequestCloudProviders() {
    yield takeLatest('cloudProviders/requestCloudProviders', requestCloudProviders);
}
